export default "__VITE_ASSET__BnnUAUPz__";